import { createClient } from "contentful"

export const client = createClient({
     // This is the space ID. A space is like a project folder in Contentful terms
     space: 'xe2hmr0j2c1z',
     // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
     accessToken: 'uquROwzGNor6i0-FV4MYzDG9pUHXkOzv4Tj1icmJdug'
});
